module.exports = __webpack_public_path__ + "static/night-lights-c41e27775baff671df4e8ef36fc511c0.mp3";